import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterLink,
  IonToolbar,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  bulbOutline,
  calendarOutline,
  carOutline,
  close,
  documentTextOutline,
  globeOutline,
  help,
  helpCircleOutline,
  home,
  informationCircleOutline,
  listOutline,
  mailOutline,
  openOutline,
  settings,
  starOutline,
  trophy,
} from 'ionicons/icons';
import { MenuCopyrightComponent } from './ui/menu-copyright/menu-copyright.component';
import { MenuProfileComponent } from './ui/menu-profile/menu-profile.component';
import { MenuSocialComponent } from './ui/menu-social/menu-social.component';

export interface NavigationItem {
  title: string;
  url: string;
  icon: string;
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MenuProfileComponent,
    IonHeader,
    IonRouterLink,
    IonMenu,
    IonContent,
    IonToolbar,
    IonButtons,
    IonMenuToggle,
    IonButton,
    IonIcon,
    IonList,
    IonItem,
    MenuSocialComponent,
    MenuCopyrightComponent,
  ],
})
export class MenuComponent {
  navigate: NavigationItem[] = [];

  constructor() {
    this.sideMenu();
    addIcons({
      close,
      bulbOutline,
      home,
      calendarOutline,
      help,
      settings,
      documentTextOutline,
      carOutline,
      trophy,
      starOutline,
      informationCircleOutline,
      mailOutline,
      helpCircleOutline,
      openOutline,
      globeOutline,
      listOutline,
    });
  }

  sideMenu() {
    this.navigate = [
      {
        title: 'Van',
        url: '/tabs/van',
        icon: 'car-outline',
      },
      {
        title: 'Events',
        url: '/tabs/events',
        icon: 'calendar-outline',
      },
      {
        title: 'Packing Lists',
        url: '/tabs/packing-lists',
        icon: 'list-outline',
      },
      {
        title: 'Manage Vans',
        url: '/vans',
        icon: 'car-outline',
      },
      {
        title: 'About',
        url: '/about',
        icon: 'help',
      },
      {
        title: 'Settings',
        url: '/settings',
        icon: 'settings',
      },
      {
        title: 'Premium',
        url: '/premium',
        icon: 'trophy',
      },
      {
        title: 'Privacy Policy',
        url: '/privacy-policy',
        icon: 'document-text-outline',
      },
      {
        title: 'Terms of Use',
        url: '/terms',
        icon: 'document-text-outline',
      },
    ];
  }
}
